import React, { createContext, useCallback, useEffect, useState } from "react";

export const CartContext = createContext();

const readStorage = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => readStorage("cartItems", []));
  const [wishlist, setWishlist] = useState(() => readStorage("wishlist", []));

  useEffect(() => localStorage.setItem("cartItems", JSON.stringify(cartItems)), [cartItems]);
  useEffect(() => localStorage.setItem("wishlist", JSON.stringify(wishlist)), [wishlist]);

  const addToCart = (id, quantity = 1, size = "", color = "") => {
    setCartItems((items) => {
      const match = items.find((item) => item.id === id && item.size === size && item.color === color);
      return match
        ? items.map((item) =>
            item.id === id && item.size === size && item.color === color
              ? { ...item, quantity: item.quantity + quantity }
              : item
          )
        : [...items, { id, quantity, size, color }];
    });
  };

  const removeFromCart = (id, size, color) =>
    setCartItems((items) => items.filter((item) => !(item.id === id && item.size === size && item.color === color)));

  const updateQuantity = (id, size, color, quantity) =>
    setCartItems((items) =>
      items.map((item) =>
        item.id === id && item.size === size && item.color === color
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );

  const toggleWishlist = (id) =>
    setWishlist((items) => (items.includes(id) ? items.filter((item) => item !== id) : [...items, id]));
  const clearCart = useCallback(() => setCartItems([]), []);

  return (
    <CartContext.Provider value={{ cartItems, wishlist, addToCart, removeFromCart, updateQuantity, clearCart, toggleWishlist }}>
      {children}
    </CartContext.Provider>
  );
};
